import { Injectable } from '@angular/core';
import { User } from "./user";
import { Observable } from "rxjs/Observable";
import { DatePipe } from '@angular/common';
import { SearchTableState } from "../search-table-state";
import { BaseService } from "../base.service";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class UserManagementService extends BaseService {

    private static searchUrl: string = '/api/users/search';
    private static exportExcelUrl: string = '/api/users/exportExcel';
    public static userUrl: string = '/api/users';
    private static setUserStatusUrl: string = '/api/users/setUserStatus';
    private static setBulkUserStatusUrl: string = '/api/users/setBulkUserStatus';
    public searchTableState: SearchTableState = null;

    constructor(
        private http: HttpClient,
        private datePipe: DatePipe
    ) {
        super();
        this.searchTableState = new SearchTableState();
        this.searchTableState.propertyName = 'CreatedDateUtc';
    }

    private searchTableStateCopy(): any {
        let copy: any = Object.assign({}, this.searchTableState);
        /* Disable refresh search */
        copy.lastRefreshed = new Date();
        if (copy.lastRefreshed) {
            copy.lastRefreshed = new Date(copy.lastRefreshed.getTime() + -1 * (new Date().getTimezoneOffset() * 60000));
        }
        this.updateFilterField(copy, 'email', 'emailCondition');
        this.updateFilterField(copy, 'mobileNumber', 'mobileNumberCondition');
        this.updateFilterField(copy, 'externalId', 'externalIdCondition');
        return copy;
    }

    public setBulkUserStatus(userIds: Array<string>, active: boolean): Observable<any> {
        return this.http.post<any>(UserManagementService.setBulkUserStatusUrl, { ids: userIds, active: active });
    }

    public setUserStatus(userId: string, active: boolean): Observable<any> {
        return this.http.post<any>(UserManagementService.setBulkUserStatusUrl, { id: userId, active: active });
    }

    public search(): Observable<Array<User>> {
        let copy = this.searchTableStateCopy();
        return this.http.post<any>(UserManagementService.searchUrl, copy)
            .map(data => {
                let users: Array<User> = this.dataToUser(data);
                this.searchTableState.totalItems = parseInt(users.length ? data[0].Total : 0);
                return users;
            });
    }

    public exportExcel(): Observable<any> {
        let copy = this.searchTableStateCopy();
        return this.http.post<any>(UserManagementService.exportExcelUrl, copy, { responseType: 'blob' as 'json' });
    }

    private dataToUser(data: any): Array<User> {
        let users = new Array<User>();
        if (data == null) {
            return users;
        }
        for (let d of data) {
            let user = new User();
            user.userId = d.UserId;
            user.mobileNumber = d.MobileNumber;
            user.email = d.Email;
            user.firstName = d.FirstName;
            user.surname = d.Surname;
            user.createdDateUtc = this.datePipe.transform(new Date(d.CreatedDateUtc), 'yyyy-MM-dd HH:mm');
            user.statusId = d.StatusId == 2 || d.StatusId == 4;
            users.push(user);
        }
        return users;
    }

    public getUser(id: string): Observable<User> {
        let params = new HttpParams()
            .set('id', id);
        return this.http.get<any>(UserManagementService.userUrl, { params: params })
            .map(data => {
                let user = new User();
                user.userId = data.UserId;
                user.mobileNumber = data.MobileNumber;
                user.email = data.Email;
                user.firstName = data.FirstName;
                user.surname = data.Surname;
                user.permissionsValue = parseInt(data.PermissionsValue);
                user.loyaltySiteId = data.LoyaltySiteId;
                user.roleId = data.RoleId;
                return user;
            });
    }
};


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/user/user-management.service.ts